import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type CreateSaltoSpaceUserRequest = {
  email: string
  buildingId: number
}

const createSaltoSpaceUser = async (data: CreateSaltoSpaceUserRequest) => {
  const response = await authAPI.post('/salto-space/user', data)
  return response.data
}

export const useCreateSaltoSpaceUser = () =>
  useMutation({
    mutationFn: createSaltoSpaceUser,
  })
